<template>
  <div class="mx-4 mb-4">
    <div class="mb-3 d-flex">
      <span class="mr-4 font-weight-bold">{{
        $l('INDEX.amz_sku_label_material_drawing_file') || '物料图稿文件'
      }}</span>
      <el-button size="mini" @click="onAdd">{{
        $l('INDEX.amz_sku_label_add_upload') || '新增上传'
      }}</el-button>
    </div>
    <div>
      <div
        class="mb-2"
        v-for="(item, index) in materialImageList"
        :key="item.amzSkuMaterialImgCode || item.id"
      >
        <ArtworkItem
          :item="item"
          :index="index"
          :fileIcons="fileIcons"
          @save="saveItem"
          @delete="deleteItem"
        />
      </div>
      <el-empty
        v-if="!materialImageList || !materialImageList.length"
        :description="$l('INDEX.tips_no_data') || '暂无数据！'"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import ArtworkItem from './ArtworkItem.vue'
import EditLoading from '@/mixins/edit-loading'
import { sizeOf } from '@/libs/util'
import { request } from '@/api/service'
export default {
  components: {
    ArtworkItem,
  },
  mixins: [EditLoading],
  props: {
    amzSkuMaterialCode: String,
    amzSkuCode: String,
  },
  data() {
    return {
      materialImageList: [],
      fileIcons: {},
    }
  },
  created() {
    this.getData()
    this.getFileIcons()
  },
  methods: {
    // 获取物料图稿文件
    getData() {
      this.loadingOpen()
      this.$api
        .ecomAmzSkuMaterialImageListApi({
          amzSkuMaterialCode: this.amzSkuMaterialCode,
        })
        .then(({ status, body }) => {
          if (status == 200) {
            this.materialImageList = body.data?.map((t) => ({
              ...t,
              readonly: true,
              fileSizeText: sizeOf(t.fileSize),
            }))
          }
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    getFileIcon(fileName) {
      const getFileType = (filename) => {
        if (!filename) return ''
        if (!filename.includes('.')) return ''
        return filename.split('.').pop()
      }

      const fileType = getFileType(fileName) || 'OTHER'
      return this.$osscdn(
        this.fileIcons[fileType.toUpperCase()] || this.fileIcons['OTHER']
      )
    },
    async onUpload(file) {
      if (file.status !== 'ready') {
        return
      }
      const { status, body } = await this.$api.SYS_UPLOAD(file.raw)
      if (status != 200) {
        this.$message.error('上传失败')
        return
      }
      this.materialImageList.push({
        url: body.url,
        fileName: file.name,
        fileSize: file.size,
      })
    },
    onAdd() {
      this.materialImageList.unshift({
        id: this.getID(),
        readonly: false,
      })
    },
    async saveItem(item) {
      if (this.loadingOpen()) return
      let file = {}
      if (item.file) {
        const { status, body } = await this.$api.SYS_UPLOAD(item.file)
        if (status != 200) {
          this.$message.error(
            this.$l('INDEX.message_material_upload_error') || '上传失败'
          )
          this.loadingClose()
          return
        }
        file = body || {}
      }

      await this.$api
        .ecomAmzSkuMaterialImageSaveApi({
          amzSkuMaterialImgCode: item.amzSkuMaterialImgCode,
          amzSkuMaterialCode: this.amzSkuMaterialCode,
          amzSkuCode: this.amzSkuCode,
          seqno: 1,
          sortOrder: 1,
          fileCode: file.fileId,
          fileUrl: file.url,
          fileName: item.fileName,
          fileSize: item.fileSize,
          fileDesc: item.fileDesc,
          displayImageUrl: item.displayImageUrl,
          originImageUrl: file.url,
          originImageCode: file.fileId,
        })
        .then(({ status }) => {
          if (status != 200) {
            this.$message.error(
              this.$l('INDEX.message_material_save_error') || '保存失败'
            )
            this.loadingClose()
            return
          }
          this.$message.success(
            this.$l('INDEX.message_material_save_success') || '保存成功'
          )
          this.getData()
          this.loadingClose()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    deleteItem({ index }) {
      const item = this.materialImageList[index]
      if (!item) {
        return
      }

      if (!item.fileName && !item.fileDesc && !item.amzSkuMaterialImgCode) {
        this.materialImageList.splice(index, 1)
        return
      }

      this.$confirm(
        this.$l('INDEX.message_material_del_content') || '确认要删除吗？',
        this.$l('INDEX.message_material_del_title') || '提示',
        {
          confirmButtonText:
            this.$l('INDEX.message_material_del_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.message_material_del_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          if (!item.amzSkuMaterialImgCode) {
            this.materialImageList.splice(index, 1)
            return
          }
          if (this.loadingOpen()) return

          this.$api
            .ecomAmzSkuMaterialImageDelApi({
              amzSkuMaterialImgCode: item.amzSkuMaterialImgCode,
            })
            .then(({ status }) => {
              if (status != 200) {
                this.$message.error(
                  this.$l('INDEX.message_material_del_error') || '删除失败'
                )
                this.loadingClose()
                return
              }
              this.$message.success(
                this.$l('INDEX.message_material_del_success') || '删除成功'
              )
              this.getData()
              this.loadingClose()
            })
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    /**
     * 生成一个临时ID
     */
    getID() {
      let idStr = Date.now().toString(36)
      idStr += Math.random()
        .toString(36)
        .substring(2)
      return idStr
    },
  },
}
</script>
<style scoped></style>
